import { Strategy } from 'utility-ts-strategy';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import { ISectionTileErrorNotificationMessage } from '../../../interfaces/scheduler_interfaces';

export let TileErrorMessageTypesAndMessagesStrategy = new Strategy<ISectionTileErrorNotificationMessage>({
  ADD: {
    show_icon: true,
    title: 'This course could not be registered.'
  },
  DROP: {
    show_icon: true,
    title: 'This course could not be dropped.'
  },
  WAITLIST_ADD: {
    show_icon: false,
    title: 'We were not able to add you on the waitlist.'
  },
  WAITLIST_DROP: {
    show_icon: false,
    title: 'We were not able to remove you from the waitlist.'
  },
  SWAP: {
    show_icon: true,
    title: 'We were unable to complete your swap.'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/strategies/section_tile_error_strategy.ts